import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { Provider } from "react-redux";
import store from "./store";
import { AuthProvider } from "./Context/AuthContext";
import { SearchProvider } from "./Context/SearchContext";
import { CartProvider } from "./Context/CartContext";
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider>
        <SearchProvider>
          <CartProvider>
            <Router>
              <App />
            </Router>
          </CartProvider>
        </SearchProvider>
      </AuthProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
